import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { localAxiosGet } from '../../../Axios/axios';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Rating,
  Paper,
  Chip,
  Tabs,
  Tab,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  FormControlLabel,
  Checkbox,
  TextField,
  Snackbar,
} from '@mui/material';
import {
  Code as CodeIcon,
  Lightbulb as LightbulbIcon,
  ChatBubble as ChatBubbleIcon,
  Group as GroupIcon,
  AccessTime as AccessTimeIcon,
  WorkspacePremium,
  TrendingUp,
  Assessment,
  ThumbUp,
  Close,
  Info,
} from '@mui/icons-material';
import PastApparaisalOfEmployee from '../../Manager/Performance/PastApparaisalOfEmployee';


const promotionData = {
  isEligible: true,
  currentRole: "Software Engineer",
  newRole: "Senior Engineer",
  salaryIncrement: 12,
  bonus: 50000
};


const PerfomanceRatingsAndFeedBack = () => {
  const [timeRange, setTimeRange] = useState(0);
  const [loading, setLoading] = useState(false);
  const [openAcknowledgeDialog, setOpenAcknowledgeDialog] = useState(false);
  const [acknowledgeChecked, setAcknowledgeChecked] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [acknowledgeComments, setAcknowledgeComments] = useState('');
  const [employeeRatings, setEmployeeRatings] = useState([]);
  const [employeeFeedBack, setEmployeeFeedback] = useState(null);

  const emp_id = localStorage.getItem('userId');
  const accessToken = localStorage.getItem('accessToken');
  const [isPastAppraisalsModalOpen, setIsPastAppraisalsModalOpen] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem('userDetails'));
  // const employeeName = `${userDetails.first_name} ${userDetails.last_name}`;
  const currentYear = new Date().getFullYear();


  useEffect(() => {
    if (emp_id && accessToken) {
      getEmployeeRatings();
      getEmployeeFeedBack();
    }
  }, [emp_id, accessToken]);

  const getEmployeeRatings = async () => {
    try {
      const response = await axios(
        localAxiosGet(`/empGoal/get_rating_by_empID_and_year?emp_id=${emp_id}&appraisal_year=${currentYear}&appraisal_period=Yearly`)
        // localAxiosGet(`/empGoal/get_rating_by_empID_and_year?emp_id=${emp_id}`)

        // localAxiosGet(`/empGoal/get_rating_by_empID?emp_id=285`)
      );

      if (response.data.status === "SUCCESS") {
        setEmployeeRatings(response.data.result);
      } else {
        setEmployeeRatings([]);
        // setSnackbarMessage(response.data.message || "Failed to fetch ratings");
        // setSnackbarSeverity("error");
        // setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error in fetching employee ratings:", error);
      setEmployeeRatings([]);
      // setSnackbarMessage(
      //   error.response?.data?.message ||
      //   error.message ||
      //   "Something went wrong while fetching ratings"
      // );
      // setSnackbarSeverity("error");
      // setSnackbarOpen(true);
    }
  };

  const getEmployeeFeedBack = async () => {
    try {
      const response = await axios(
        localAxiosGet(`/empGoal/get_manager_feedback?emp_id=${emp_id}`)
        // localAxiosGet(`/empGoal/get_manager_feedback?emp_id=285`)
      );

      if (response.data.status === "SUCCESS") {
        setEmployeeFeedback(response.data.result[0] || null);

      } else {
        setEmployeeFeedback([]);
        // setSnackbarMessage(response.data.message || "Failed to fetch feedback");
        // setSnackbarSeverity("error");
        // setSnackbarOpen(true);
      }
    } catch (error) {
      console.error("Error in fetching employee feedback:", error);
      setEmployeeFeedback(null);
      // setSnackbarMessage(
      //   error.response?.data?.message ||
      //   error.message ||
      //   "Something went wrong while fetching feedback"
      // );
      // setSnackbarSeverity("error");
      // setSnackbarOpen(true);
    }
  };

  const handleOpenAcknowledgeDialog = () => {
    setOpenAcknowledgeDialog(true);
  };

  const handleCloseAcknowledgeDialog = () => {
    setOpenAcknowledgeDialog(false);
  };

  const handleAcknowledgeChange = (event) => {
    setAcknowledgeChecked(event.target.checked);
  };

  const handleAcknowledgeSubmit = () => {
    setSnackbarMessage('You have successfully acknowledged your performance review!');
    setSnackbarSeverity('success');
    setSnackbarOpen(true);
    setOpenAcknowledgeDialog(false);
    setAcknowledgeChecked(false);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarOpen(false);
  };

  const handleTimeRangeChange = (event, newValue) => {
    setTimeRange(newValue);
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 800);
  };

  const handlePastAppraisalsDisplay = () => {
    setIsPastAppraisalsModalOpen(true);

  }
  return (
    <div>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
          Promotion & Bonus Details
        </Typography>
        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3, background: 'linear-gradient(to right, #f9f9f9, #ffffff)' }}>
          <Grid container spacing={3}>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{
                height: '100%',
                boxShadow: 3,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #E3F2FD 0%, #BBDEFB 100%)'
              }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <WorkspacePremium sx={{ fontSize: 50, color: promotionData.isEligible ? "#4CAF50" : "#F44336" }} />
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                    Promotion Eligibility
                  </Typography>
                  <Chip
                    label={promotionData.isEligible ? "Eligible" : "Not Eligible"}
                    sx={{
                      backgroundColor: promotionData.isEligible ? "#4CAF50" : "#F44336",
                      color: "#fff",
                      fontWeight: "bold",
                      mt: 2,
                      px: 2
                    }}
                  />
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{
                height: '100%',
                boxShadow: 3,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #E8F5E9 0%, #C8E6C9 100%)'
              }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <TrendingUp sx={{ fontSize: 50, color: "#4CAF50" }} />
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                    Role Advancement
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2 }}>
                    {promotionData.currentRole}
                  </Typography>
                  <Typography variant="h6" sx={{ mt: 1, color: 'success.main', fontWeight: 'bold' }}>
                    ↓
                  </Typography>
                  <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
                    {promotionData.newRole}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{
                height: '100%',
                boxShadow: 3,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)'
              }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <Assessment sx={{ fontSize: 50, color: "#FF9800" }} />
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                    Salary Increment
                  </Typography>
                  <Typography variant="h4" sx={{ mt: 2, color: 'success.main', fontWeight: 'bold' }}>
                    +{promotionData.salaryIncrement}%
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <Card sx={{
                height: '100%',
                boxShadow: 3,
                borderRadius: 2,
                background: 'linear-gradient(135deg, #E1F5FE 0%, #B3E5FC 100%)'
              }}>
                <CardContent sx={{ textAlign: 'center', p: 3 }}>
                  <WorkspacePremium sx={{ fontSize: 50, color: "#2196F3" }} />
                  <Typography variant="h6" sx={{ mt: 2, fontWeight: 'bold' }}>
                    Performance Bonus
                  </Typography>
                  <Typography variant="h4" sx={{ mt: 2, color: 'primary.main', fontWeight: 'bold' }}>
                    ₹{promotionData.bonus.toLocaleString()}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        </Paper>
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button variant='contained' onClick={handlePastAppraisalsDisplay}>Past Appraisals</Button>
        {/* <Tabs value={timeRange} onChange={handleTimeRangeChange}>
          <Tab label="Quarterly" />
          <Tab label="Half-Yearly" />
          <Tab label="Yearly" />
        </Tabs> */}
      </Box>
      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
          Performance Ratings
        </Typography>
        {employeeRatings && employeeRatings.length > 0 ? (
          <Grid container spacing={3}>
            {employeeRatings.map((category) => (
              <Grid item xs={12} sm={6} md={4} key={category.id}>
                <Card sx={{
                  boxShadow: 3,
                  borderRadius: 2,
                  background: `linear-gradient(135deg, white 60%, ${category.color}33 100%)`,
                  height: '100%'
                }}>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" sx={{ mb: 1 }}>
                      {category.category_name}
                    </Typography>
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                      <Rating
                        value={category.rating}
                        precision={0.5}
                        readOnly
                        sx={{
                          '& .MuiRating-iconFilled': {
                            color: category.color,
                          }
                        }}
                      />
                      <Typography variant="h5" fontWeight="bold" sx={{ color: category.color }}>
                        {category.rating}/5
                      </Typography>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        ) : (
          <Paper sx={{
            p: 4,
            borderRadius: 2,
            boxShadow: 2,
            textAlign: 'center',
            backgroundColor: '#f8f9fa',
            border: '1px solid #e9ecef'
          }}>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 500,
                color: '#6c757d',
                fontStyle: 'italic'
              }}
            >
              No ratings available
            </Typography>
            <Typography
              variant="body2"
              sx={{
                color: '#adb5bd',
                mt: 1
              }}
            >
              Performance ratings will be available after appraisal
            </Typography>
          </Paper>
        )}
      </Box>

      <Box sx={{ mb: 6 }}>
        <Typography variant="h5" fontWeight="bold" sx={{ mb: 2 }}>
          Manager Feedback
        </Typography>

        <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 3 }}>
          {employeeFeedBack &&
            (employeeFeedBack.strengths ||
              employeeFeedBack.area_of_improvement ||
              employeeFeedBack.goals_for_next_period) ? (
            <Grid container spacing={3}>
              <Grid item xs={12} md={4}>
                <Card sx={{
                  height: '100%',
                  background: 'linear-gradient(135deg, white 60%, #4CAF5033 100%)',
                  border: '1px solid #4CAF5033'
                }}>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" color="success.main" sx={{ mb: 2 }}>
                      Strengths
                    </Typography>
                    <Typography variant="body1">
                      {employeeFeedBack.strengths || "No strengths mentioned"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card sx={{
                  height: '100%',
                  background: 'linear-gradient(135deg, white 60%, #FF980033 100%)',
                  border: '1px solid #FF980033'
                }}>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" color="warning.main" sx={{ mb: 2 }}>
                      Areas for Improvement
                    </Typography>
                    <Typography variant="body1">
                      {employeeFeedBack.area_of_improvement || "No areas for improvement mentioned"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} md={4}>
                <Card sx={{
                  height: '100%',
                  background: 'linear-gradient(135deg, white 60%, #2196F333 100%)',
                  border: '1px solid #2196F333'
                }}>
                  <CardContent>
                    <Typography variant="h6" fontWeight="bold" color="primary.main" sx={{ mb: 2 }}>
                      Goals for Next Period
                    </Typography>
                    <Typography variant="body1">
                      {employeeFeedBack.goals_for_next_period || "No goals mentioned"}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          ) : (
            <Paper sx={{ 
              p: 4, 
              borderRadius: 2, 
              boxShadow: 2, 
              textAlign: 'center',
              backgroundColor: '#f8f9fa',
              border: '1px solid #e9ecef'
            }}>
              <Typography 
                variant="h6" 
                sx={{ 
                  fontWeight: 500,
                  color: '#6c757d',
                  fontStyle: 'italic'
                }}
              >
                No feedback is added
              </Typography>
              <Typography 
                variant="body2" 
                sx={{ 
                  color: '#adb5bd',
                  mt: 1
                }}
              >
                Manager feedback will be available after review
              </Typography>
            </Paper>
          )}
        </Paper>

      </Box>


      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>

        <Button
          variant="contained"
          color="primary"
          onClick={handleOpenAcknowledgeDialog}
        >
          Acknowledge Review
        </Button>
      </Box>
      <Dialog
        open={openAcknowledgeDialog}
        onClose={handleCloseAcknowledgeDialog}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
          }
        }}
      >
        <DialogTitle sx={{
          bgcolor: 'primary.main',
          color: 'white',
          fontWeight: 'bold',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          p: 2
        }}>
          <Box display="flex" alignItems="center">
            <ThumbUp sx={{ mr: 1 }} />
            Acknowledge Performance Review
          </Box>
          <IconButton
            aria-label="close"
            onClick={handleCloseAcknowledgeDialog}
            sx={{
              color: 'white'
            }}
          >
            <Close />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ p: 3, mt: 2 }}>
          <Paper sx={{ p: 3, borderRadius: 2, boxShadow: 2, mb: 3, background: 'linear-gradient(135deg, #ffffff 0%, #f3f4f6 100%)' }}>
            <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: 'primary.main' }}>
              Review Acknowledgment
            </Typography>

            <Box sx={{ mb: 3, p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.1)' }}>
              <Typography variant="subtitle1" fontWeight="bold">
                Review Period: Q2 2023
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                Overall Rating: <span style={{ fontWeight: 'bold', color: '#4CAF50' }}>4.2/5.0</span>
              </Typography>
              <Typography variant="body2">
                Manager: <span style={{ fontWeight: 'bold' }}>John Smith</span>
              </Typography>
              <Typography variant="body2">
                Review Date: <span style={{ fontWeight: 'bold' }}>July 15, 2023</span>
              </Typography>
            </Box>

            <Typography variant="body1" sx={{ mb: 3 }}>
              By acknowledging this performance review, you confirm that you have read and understood the feedback provided by your manager. This does not necessarily indicate agreement with all aspects of the review, but acknowledges that you have reviewed the content.
            </Typography>

            <Box sx={{ p: 2, borderRadius: 2, bgcolor: 'rgba(33, 150, 243, 0.1)', mb: 3 }}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ display: 'flex', alignItems: 'center' }}>
                <Info sx={{ mr: 1, color: 'primary.main' }} />
                Important Information
              </Typography>
              <Typography variant="body2" sx={{ mt: 1 }}>
                • The performance review will be stored in your employee record<br />
                • You may request a follow-up discussion with your manager<br />
                • Any goals outlined in the review will be tracked in future evaluations<br />
                • Promotion and bonus decisions are based on this and other performance indicators
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', p: 2, borderRadius: 2, bgcolor: 'rgba(76, 175, 80, 0.1)' }}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={acknowledgeChecked}
                    onChange={handleAcknowledgeChange}
                    sx={{
                      '&.Mui-checked': {
                        color: '#4CAF50',
                      },
                    }}
                  />
                }
                label={
                  <Typography variant="body1">
                    I acknowledge that I have reviewed and understood the performance evaluation for the current period.
                  </Typography>
                }
              />
            </Box>

            <TextField
              fullWidth
              label="Additional Comments (Optional)"
              name="acknowledgeComments"
              multiline
              rows={3}
              value={acknowledgeComments}
              onChange={(e) => setAcknowledgeComments(e.target.value)}
              placeholder="Add any comments you'd like to include with your acknowledgment..."
              variant="outlined"
              sx={{
                mt: 3,
                background: 'white',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2196F380',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#2196F3',
                },
              }}
            />
          </Paper>
        </DialogContent>

        <DialogActions sx={{ p: 3, pt: 0 }}>
          <Button
            variant="outlined"
            onClick={handleCloseAcknowledgeDialog}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!acknowledgeChecked}
            onClick={handleAcknowledgeSubmit}
            startIcon={<ThumbUp />}
          >
            Submit Acknowledgment
          </Button>
        </DialogActions>
      </Dialog>

      {/* Past Appraisals Modal */}
      <PastApparaisalOfEmployee
        open={isPastAppraisalsModalOpen}
        onClose={() => setIsPastAppraisalsModalOpen(false)}
        selectedemployeeId={emp_id}
        // employeeName={employeeName}
      />


      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        message={snackbarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        action={
          <IconButton
            size="small"
            color="inherit"
            onClick={handleSnackbarClose}
          >
            <Close fontSize="small" />
          </IconButton>
        }
      />
    </div>
  )
}

export default PerfomanceRatingsAndFeedBack;